import { Button } from "@/design-system/Button/Button";
import { useTranslation } from "@repo/shared/i18n";
import { ArrowUpRight } from "lucide-react";

interface ViewAllButtonProps {
  onClick: () => void;
}

export const ViewAllButton = ({ onClick }: ViewAllButtonProps) => {
  const { t } = useTranslation("frontPage");
  return (
    <Button
      iconPosition="right"
      variant="custom"
      size="small"
      className="border text-blue-500 border-blue-500"
      onClick={onClick}
      icon={<ArrowUpRight className="w-4 h-4" />}
    >
      {t("viewAll")}
    </Button>
  );
};
